import React from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import { AUTHENTICATED_ENTRY } from "configs/AppConfig";

const PublicRoute = () => {
  const location = useLocation();
  const { token, redirect } = useSelector((state) => state.auth);
  // If route is devotee-qr, allow access without redirect
  if (location.pathname.startsWith("/devotee-qr")) {
    return <Outlet />;
  }

  return token ? <Navigate to={redirect || AUTHENTICATED_ENTRY} /> : <Outlet />;
};

export default PublicRoute;
